import type { BulkConsignmentOrderRequest } from '@/types/consignmentOrders';
import type { BulkConsignmentOrderFormData } from './types';

/**
 * Transforms bulk consignment order form data into a single bulk order request
 * Backend will create multiple consignment orders (one per product)
 * Automatically adds ta_consignmenttype: 953870001 (Trunk Stock)
 */
export const transformBulkFormToBulkConsignmentOrderRequest = (
	formData: BulkConsignmentOrderFormData,
): BulkConsignmentOrderRequest => {
	const orderRequestDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

	const payload: BulkConsignmentOrderRequest = {
		// Common fields shared across all orders
		ta_status: String(formData.status),
		statecode: 1,
		statuscode: 1,
		ta_fedexshippingmethod: formData.shipping?.value ? parseInt(String(formData.shipping.value)) : 0,
		ta_orderrequestdate: orderRequestDate,
		'ta_Clinic@odata.bind': `accounts(${formData.clinic?.value})`,
		ta_clinicpo: formData.clinicPO,
		'ta_ShippingLocation@odata.bind': `ta_shippinglocationses(${formData.shippingLocation?.value})`,
		ta_comments: formData.comments || '',
		ta_consignmenttype: formData.consignmentType?.value ? parseInt(String(formData.consignmentType.value)) : 953870001,

		// Products array - each will become a separate order on backend
		products: formData.products.map((productField) => ({
			'ta_SKU@odata.bind': `ta_products(${productField.productSize})`,
			ta_quantity: String(productField.quantity),
		})),
	};

	// Optional physician field - only add if it exists
	if (formData.physician?.value) {
		const physicianId = String(formData.physician.value).replace(/[{}]/g, '');
		payload['ta_Doctor@odata.bind'] = `contacts(${physicianId})`;
	}

	return payload;
};

